<section class="cf-card">
  <h2 class="cf-card__title">{{ section.label }}</h2>

  <div class="cf-card__body">

    <div class="cf-file-list" *ngIf="files.length">
      <div class="cf-file-row" *ngFor="let file of files; let i = index; trackBy: trackByKey">
        <svg class="cf-file-row__icon" width="24" height="24" viewBox="0 0 36 36" fill="none" aria-hidden="true">
          <path d="M21 3H9a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V12L21 3z" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 3v9h9" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="cf-file-row__name" [title]="file.name">{{ file.name }}</span>
        <div class="cf-file-row__actions">
          <button type="button" class="cf-file-row__btn" [disabled]="busy" (click)="openPreview(file)">
            {{ LABELS.PREVIEW }}
          </button>
          <button
            type="button"
            class="cf-file-row__btn cf-file-row__btn--remove"
            [disabled]="busy"
            (click)="removeFile(i)"
          >
            {{ LABELS.REMOVE }}
          </button>
        </div>
      </div>
    </div>

    <div class="cf-file-rejected" *ngFor="let item of rejected">
      <strong>{{ item.name }}</strong> — {{ item.reason }}
    </div>

    <div class="cf-file-rejected" *ngIf="!isTypeAllowed">
      {{ TYPE_NOT_ALLOWED_MESSAGE }}
    </div>

    <div
      class="cf-dropzone"
      *ngIf="isTypeAllowed"
      [class.cf-dropzone--over]="isDragging"
      [class.cf-dropzone--error]="showRequiredError"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onDrop($event)"
    >
      <input
        #fileInput
        type="file"
        class="cf-dropzone__input"
        [accept]="acceptAttr"
        [multiple]="allowMultiple"
        [disabled]="busy"
        (change)="onFileChange($event)"
      >

      <svg class="cf-dropzone__illustration" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="60" cy="60" r="55" stroke="#D0D5DD" stroke-width="1.5"/>
        <rect x="38" y="32" width="36" height="44" rx="3" stroke="#BCC0C8" stroke-width="1.5"/>
        <path d="M62 32v12h12" stroke="#BCC0C8" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M60 72V52M53 59l7-7 7 7" stroke="#BCC0C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <span class="cf-dropzone__text" *ngIf="!uploading">{{ LABELS.DROPZONE }}</span>
      <span class="cf-dropzone__text" *ngIf="uploading">{{ LABELS.UPLOADING }}</span>

      <button
        type="button"
        class="cf-dropzone__browse"
        [disabled]="busy"
        (click)="fileInput.click()"
      >
        {{ LABELS.BROWSE }}
      </button>
    </div>

    <span class="cf-field__error" *ngIf="showRequiredError">*Required</span>
  </div>
</section>
